import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, withCtx as _withCtx, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '@/assets/img/logo.png'


const _hoisted_1 = { class: "h-full flex flex-col bg-white shadow-xl rounded-lg overflow-hidden mx-4 lg:ml-4 lg:mr-0" }
const _hoisted_2 = { class: "px-6 py-4 flex flex-shrink-0 items-center justify-center border-b border-gray-100" }
const _hoisted_3 = { class: "flex-1 px-4 py-4 space-y-1.5 overflow-y-auto text-[0.85rem]" }
const _hoisted_4 = { class: "flex items-center justify-center w-8 h-8 rounded-lg bg-[#4b5c4b] text-white shadow-sm mr-3 group-hover:scale-110 transition-transform" }
const _hoisted_5 = { class: "flex items-center justify-center w-8 h-8 rounded-lg bg-[#4b5c4b] text-white shadow-sm mr-3 group-hover:scale-110 transition-transform" }
const _hoisted_6 = { class: "flex items-center justify-center w-8 h-8 rounded-lg bg-[#4b5c4b] text-white shadow-sm mr-3 group-hover:scale-110 transition-transform" }
const _hoisted_7 = { class: "flex items-center justify-center w-8 h-8 rounded-lg bg-[#4b5c4b] text-white shadow-sm mr-3 group-hover:scale-110 transition-transform" }
const _hoisted_8 = { class: "flex items-center justify-center w-8 h-8 rounded-lg bg-[#4b5c4b] text-white shadow-sm mr-3 group-hover:scale-110 transition-transform" }
const _hoisted_9 = { class: "flex items-center justify-center w-8 h-8 rounded-lg bg-[#4b5c4b] text-white shadow-sm mr-3 group-hover:scale-110 transition-transform" }
const _hoisted_10 = { class: "flex-shrink-0 p-4 border-t border-gray-100" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _cache[2] || (_cache[2] = _createElementVNode("a", {
        href: "/",
        class: "block"
      }, [
        _createElementVNode("img", {
          src: _imports_0,
          class: "h-12 w-auto object-contain",
          alt: "Logo"
        })
      ], -1)),
      _createElementVNode("button", {
        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('close-sidebar'))),
        class: "lg:hidden absolute top-6 right-6 p-2 bg-gray-50 rounded-full text-gray-500 hover:text-gray-800 hover:bg-gray-200 transition-colors"
      }, [
        _createVNode(_component_font_awesome_icon, {
          icon: "times",
          class: "h-5 w-5"
        })
      ])
    ]),
    _createElementVNode("nav", _hoisted_3, [
      _createVNode(_component_router_link, {
        to: "/private/dashboard",
        class: "flex items-center px-4 py-3 rounded-xl text-gray-600 hover:bg-gray-100 transition-colors group",
        "active-class": "bg-gray-50 text-green-800 shadow-sm font-semibold"
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_4, [
            _createVNode(_component_font_awesome_icon, {
              icon: ['fas', 'house'],
              class: "text-sm"
            })
          ]),
          _createElementVNode("span", null, _toDisplayString(_ctx.$t('menu.dashboard')), 1)
        ]),
        _: 1
      }),
      _createVNode(_component_router_link, {
        to: "/private/solicitudReuniones",
        class: "flex items-center px-4 py-3 rounded-xl text-gray-600 hover:bg-gray-100 transition-colors group",
        "active-class": "bg-gray-50 text-green-800 shadow-sm font-semibold"
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_5, [
            _createVNode(_component_font_awesome_icon, {
              icon: ['far', 'handshake'],
              class: "text-sm"
            })
          ]),
          _createElementVNode("span", null, _toDisplayString(_ctx.$t('menu.solicitar.reunion')), 1)
        ]),
        _: 1
      }),
      _createVNode(_component_router_link, {
        to: "/private/agenda",
        class: "flex items-center px-4 py-3 rounded-xl text-gray-600 hover:bg-gray-100 transition-colors group",
        "active-class": "bg-gray-50 text-green-800 shadow-sm font-semibold"
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_6, [
            _createVNode(_component_font_awesome_icon, {
              icon: ['far', 'calendar'],
              class: "text-sm"
            })
          ]),
          _createElementVNode("span", null, _toDisplayString(_ctx.$t('menu.agenda')), 1)
        ]),
        _: 1
      }),
      _createVNode(_component_router_link, {
        to: "/private/bloqueoHorario",
        class: "flex items-center px-4 py-3 rounded-xl text-gray-600 hover:bg-gray-100 transition-colors group",
        "active-class": "bg-gray-50 text-green-800 shadow-sm font-semibold"
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_7, [
            _createVNode(_component_font_awesome_icon, {
              icon: ['fas', 'ban'],
              class: "text-sm"
            })
          ]),
          _createElementVNode("span", null, _toDisplayString(_ctx.$t('menu.bloquear.horario')), 1)
        ]),
        _: 1
      }),
      _createVNode(_component_router_link, {
        to: "/private/mensajes",
        class: "flex items-center px-4 py-3 rounded-xl text-gray-600 hover:bg-gray-100 transition-colors group",
        "active-class": "bg-gray-50 text-green-800 shadow-sm font-semibold"
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_8, [
            _createVNode(_component_font_awesome_icon, {
              icon: ['far', 'fa-envelope'],
              class: "text-sm"
            })
          ]),
          _createElementVNode("span", null, _toDisplayString(_ctx.$t('menu.mensajes')), 1)
        ]),
        _: 1
      }),
      _createVNode(_component_router_link, {
        to: "/private/perfil",
        class: "flex items-center px-4 py-3 rounded-xl text-gray-600 hover:bg-gray-100 transition-colors group",
        "active-class": "bg-gray-50 text-green-800 shadow-sm font-semibold"
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_9, [
            _createVNode(_component_font_awesome_icon, {
              icon: ['far', 'user'],
              class: "text-sm"
            })
          ]),
          _createElementVNode("span", null, _toDisplayString(_ctx.$t('menu.mi.perfil')), 1)
        ]),
        _: 1
      })
    ]),
    _createElementVNode("div", _hoisted_10, [
      _createElementVNode("button", {
        onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.logout && _ctx.logout(...args))),
        class: "w-full text-sm font-bold text-white py-3 bg-gradient-to-r from-[#424c42] to-[#bbc1a9] shadow-md rounded-xl transform transition-transform duration-200 hover:scale-105 active:scale-95"
      }, [
        _createVNode(_component_font_awesome_icon, { icon: ['fas', 'fa-arrow-right-from-bracket'] }),
        _createTextVNode(" " + _toDisplayString(_ctx.$t('menu.salir')), 1)
      ])
    ])
  ]))
}